<template>
  <b-row class="mt-5">
    <b-col cols="3">
      <b-skeleton-img no-aspect height="30px" />
      <br />
      <b-skeleton-img class="mb-3" no-aspect height="24px" />
      <b-skeleton-img class="mb-3" no-aspect height="24px" />
      <b-skeleton-img class="mb-3" no-aspect height="24px" />
      <b-skeleton-img class="mb-3" no-aspect height="24px" />
      <b-skeleton-img class="mb-3" no-aspect height="24px" />
    </b-col>

    <b-col cols="9">
      <div>
        <h2 class="fw-600 mb-3 mb-5 text-center">
          <b-skeleton-img no-aspect height="30px" width="40%" />
        </h2>

        <b-table-simple responsive class="disclosure-table lg border-bottom mb-5">
          <b-tbody class="mb-2 border-0">
            <b-tr>
              <b-td class="py-1 pl-1">
                <span class="fw-500 f-120">
                  <b-skeleton-img no-aspect height="30px" width="40%" />
                </span>
                <span class="gray-500 f-90 fw-400 ml-1"> </span>
              </b-td>
            </b-tr>

            <b-tr>
              <b-td class="" style="max-width: 200mm">
                <div class="mb-3">
                  <b-skeleton-img no-aspect height="30px" width="40%" />
                  <b-skeleton-img no-aspect height="30px" width="40%" />
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DataCenterLoading'
};
</script>

<style></style>
